import React, { Component, Fragment } from 'react'

import ReactToPrint from 'react-to-print'
import moment from 'moment'

import { request } from 'core/constants'

import { ga } from '../../../../izee-app/src/services/firebase'

import { cnpjValidation } from 'utils/cnpjValidation'
import { goodObject, rawNumber } from 'utils/utils'
import { cpfValidation } from 'utils/cpfValidation'

import PersonalDataClient from 'features/components/fieldsGroup/PersonalDataClient'
import FullTradingAddress from 'features/components/fieldsGroup/FullTradingAddress'
import PersonalDataSpouse from 'features/components/fieldsGroup/PersonalDataSpouse'
import FullAddress from 'features/components/fieldsGroup/FullAddress'
import formCreator from 'features/components/formCreator'

import Modal from 'components/lib/RegisterFormModal'
import ConfirmationModal from 'components/lib/Modal'
import SmallModal from 'components/lib/Modal'
import Button from 'components/lib/Button'
import Icon from 'components/lib/Icon'
import Grid from 'components/lib/Grid'

import DataSpouse from 'components/Proposal/components/PersonalDataSpouse'
import PersonalData from 'components/Proposal/components/PersonalData'
import RequestByEmail from 'components/Documents/components/Email'
import ConfirmationMessage from 'components/ConfirmationMessage'
import UserName from 'components/Proposal/components/UserName'

import Address from 'components/Proposal/components/Address'
import DocumentComponent from 'components/Documents'
import * as Constants from 'components/constants'

import ConfirmExcludeModal from 'components/ConfirmExcludeModal'

class UpdateGuarantor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showExcludeModal: false,
      success: '',
      message: '',
      formIsWorking: false,
      smallModalIsOpen: false,
      confirmationModal: false,
      selected: 0,
      formIsInvalid: false,
      fieldErrors: {},
      fields: {
        name: '',
        email: '',
        phone: '',
        cpf: '',
        identity_type: '',
        identity: '',
        identity_issuing_body: '',
        identity_expedition_date: '',
        birth_date: '',
        nationality: '',
        marital_status: '',
        marital_status_id: '',
        occupation: '',
        income: '0,00',
        income_source: '',
        income_source_id: '',
        is_student: '',
        zip_code: '',
        address: '',
        number: '',
        additional_address: '',
        state: '',
        city: '',
        neighborhood: '',
        spouse_name: '',
        spouse_email: '',
        spouse_phone: '',
        spouse_cpf: '',
        spouse_identity_type: '',
        spouse_identity: '',
        spouse_identity_issuing_body: '',
        spouse_identity_expedition_date: '',
        spouse_birth_date: '',
        spouse_nationality: '',
        spouse_occupation: '',
        spouse_status: '',
        estimated_rent_value: 1,
        spouse_income: '0,00',
        spouse_income_source: '',
        spouse_income_source_id: '',
        cnpj: '',
        corporate_name: '',
        trading_name: '',
        municipal_enrollment: '',
        state_enrollment: '',
        typeJuridical: false,
        trading_address_zip_code: '',
        trading_address_address: '',
        trading_address_number: '',
        trading_address_additional_address: '',
        trading_address_state: '',
        trading_address_city: '',
        trading_address_neighborhood: '',
      },
    }
  }

  componentDidMount() {
    const fields = (({
      name,
      email,
      phone,
      cpf,
      identity_type,
      identity,
      identity_issuing_body,
      identity_expedition_date,
      birth_date,
      nationality,
      marital_status,
      marital_status_id,
      occupation,
      income,
      income_source,
      income_source_id,
      estimated_rent_value,
      is_student,
      zip_code,
      address,
      number,
      additional_address,
      state,
      city,
      neighborhood,
      spouse_birth_date,
      spouse_cpf,
      spouse_email,
      spouse_identity,
      spouse_identity_expedition_date,
      spouse_identity_issuing_body,
      spouse_identity_type,
      spouse_is_student,
      spouse_name,
      spouse_nationality,
      spouse_occupation,
      spouse_phone,
      spouse_income,
      spouse_income_source,
      spouse_income_source_id,
      cnpj,
      corporate_name,
      trading_name,
      municipal_enrollment,
      state_enrollment,
      trading_address_zip_code,
      trading_address_address,
      trading_address_number,
      trading_address_additional_address,
      trading_address_state,
      trading_address_city,
      trading_address_neighborhood,
    }) => ({
      name,
      email,
      phone,
      cpf,
      identity_type,
      identity,
      identity_issuing_body,
      identity_expedition_date,
      birth_date,
      nationality,
      marital_status,
      marital_status_id,
      occupation,
      income,
      income_source,
      income_source_id,
      estimated_rent_value,
      is_student,
      zip_code,
      address,
      number,
      additional_address,
      state,
      city,
      neighborhood,
      spouse_birth_date,
      spouse_cpf,
      spouse_email,
      spouse_identity,
      spouse_identity_expedition_date,
      spouse_identity_issuing_body,
      spouse_identity_type,
      spouse_is_student,
      spouse_name,
      spouse_nationality,
      spouse_occupation,
      spouse_phone,
      spouse_income,
      spouse_income_source,
      spouse_income_source_id,
      cnpj,
      corporate_name,
      trading_name,
      municipal_enrollment,
      state_enrollment,
      trading_address_zip_code,
      trading_address_address,
      trading_address_number,
      trading_address_additional_address,
      trading_address_state,
      trading_address_city,
      trading_address_neighborhood,
    }))(this.props.defaultValue)

    fields.typeJuridical = this.props.defaultValue.cnpj ? true : false

    Object.keys(fields).forEach((key) => {
      if (fields[key] === null || fields[key] === undefined) {
        fields[key] = ''
        if (key == 'income') {
          fields[key] = '0,00'
        }
      }
    })

    this.setState({ fields, defaultValue: fields })
  }

  handleChange(name, value) {
    const { defaultValue } = this.state
    const updatedFields = { ...defaultValue }

    if (name === 'typeJuridical') {
      updatedFields['typeJuridical'] = value
      if (value == false) {
        updatedFields['cnpj'] = ''
        updatedFields['corporate_name'] = ''
        updatedFields['trading_name'] = ''
        updatedFields['municipal_enrollment'] = ''
        updatedFields['state_enrollment'] = ''
        updatedFields['trading_address_zip_code'] = ''
        updatedFields['trading_address_neighborhood'] = ''
        updatedFields['trading_address_city'] = ''
        updatedFields['trading_address_address'] = ''
        updatedFields['trading_address_state'] = ''
        updatedFields['trading_address_number'] = ''
        updatedFields['trading_address_additional_address'] = ''
      }

      return this.setState({
        defaultValue: updatedFields,
        fields: updatedFields,
      })
    }

    if (name === 'fullAddress') {
      updatedFields['zip_code'] = value['cep'] || ''
      updatedFields['neighborhood'] = value['bairro'] || ''
      updatedFields['city'] = value['localidade'] || ''
      updatedFields['address'] = value['logradouro'] || ''
      updatedFields['state'] = value['uf'] || ''

      return this.setState({
        defaultValue: updatedFields,
        fields: updatedFields,
      })
    }

    if (name === 'trading_address') {
      updatedFields['trading_address_zip_code'] = value['cep'] || ''
      updatedFields['trading_address_neighborhood'] = value['bairro'] || ''
      updatedFields['trading_address_city'] = value['localidade'] || ''
      updatedFields['trading_address_address'] = value['logradouro'] || ''
      updatedFields['trading_address_state'] = value['uf'] || ''

      return this.setState({
        defaultValue: updatedFields,
        fields: updatedFields,
      })
    }

    if (name === 'marital_status_id' && value) {
      const marital = Constants.MARITAL_STATUS.find((v) => v.id == value)

      if (marital) updatedFields['marital_status'] = marital
    }

    updatedFields[name] = value

    return this.setState({
      fields: updatedFields,
      defaultValue: updatedFields,
    })
  }

  forward() {
    const isValid = this.validatePersonalData()

    let { selected } = this.state

    let resumo = 0

    if (selected == resumo) {
      this.setState({ selected: ++selected })
    } else {
      if (isValid) {
        this.updateGuarantor(selected)
        if (selected == 4) return
        this.setState({ selected: ++selected })
      }
    }
  }

  behind() {
    let { selected } = this.state

    if (selected == 0) return null
    this.setState({ selected: --selected })
  }

  callBack(data) {
    let section = --data
    const { selected } = this.state
    const isValid = this.validatePersonalData()

    if (!isValid && selected > 0) {
      this.setState({ formIsInvalid: selected })
    } else {
      this.updateGuarantor()
      this.setState({
        selected: section,
        formIsInvalid: false,
      })
    }
  }

  back() {
    const {
      location: { pathname },
    } = this.props
    const newPathName = pathname.split('/')

    newPathName.pop()
    const path = newPathName.join('/')

    if (this.props.location.state) {
      if (this.props.location.state.from === 'proposal') return this.props.goBack()
    } else {
      return this.props.push(path)
    }
  }

  validatePersonalData() {
    const {
      name,
      email,
      phone,
      cpf,
      identity,
      identity_type,
      spouse_email,
      spouse_name,
      spouse_cpf,
      spouse_status,
      cnpj,
      corporate_name,
      typeJuridical,
      marital_status_id,
      income,
      income_source_id,
    } = this.state.fields

    const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)

    const fieldErrors = {}

    let isValid = true

    if (typeJuridical) {
      if (cnpj && cnpj !== '') {
        const cnpjIsValid = cnpjValidation(cnpj)

        if (!cnpjIsValid) {
          fieldErrors['cnpj'] = ['CNPJ inválido', true]
          isValid = false
        } else {
          delete fieldErrors['cnpj']
        }
      } else {
        fieldErrors['cnpj'] = ['Campo CNPJ é obrigatório', true]
        isValid = false
      }
      if (!corporate_name || corporate_name === '') {
        fieldErrors['corporate_name'] = ['Campo Razão Social é obrigatório', true]
        isValid = false
      } else {
        delete fieldErrors['corporate_name']
      }
    }

    if (name === '') {
      fieldErrors['name'] = ['Campo Nome é obrigatório', true]
      isValid = false
    } else {
      delete fieldErrors['name']
    }

    if (!emailRegex.test(email)) {
      fieldErrors['email'] = ['Email inválido', true]
      isValid = false
    } else {
      delete fieldErrors['email']
    }

    if (phone && phone !== '') {
      const plainPhone = phone.replace(/\D/g, '')
      const phoneLength = plainPhone.length

      if (phoneLength < 10) {
        fieldErrors['phone'] = ['Telefone inválido', true]
        isValid = false
      } else {
        delete fieldErrors['phone']
      }
    } else {
      fieldErrors['phone'] = ['Campo Telefone é obrigatório', true]
      isValid = false
    }

    if (!marital_status_id || marital_status_id === '') {
      fieldErrors['marital_status_id'] = ['Campo Estado civil é obrigatório', true]
      isValid = false
    } else {
      delete fieldErrors['marital_status_id']
    }

    if ((!income || income === '' || income == '0,00') && income_source_id != '1' && income_source_id != '') {
      fieldErrors['income'] = ['Campo Renda é obrigatório', true]
      isValid = false
    } else {
      delete fieldErrors['income']
    }

    if (!income_source_id || income_source_id === '') {
      fieldErrors['income_source_id'] = ['Campo Fonte de renda é obrigatório', true]
      isValid = false
    } else {
      delete fieldErrors['income_source_id']
    }

    if (cpf && cpf !== '') {
      const plainCPF = cpf.replace(/\D/g, '')
      const cpfIsValid = cpfValidation(plainCPF)

      if (!cpfIsValid) {
        fieldErrors['cpf'] = ['CPF inválido', true]
        isValid = false
      } else {
        delete fieldErrors['cpf']
      }
    } else {
      fieldErrors['cpf'] = ['Campo CPF é obrigatório', true]
      isValid = false
    }

    if (identity_type) {
      if (!identity) {
        fieldErrors['identity'] = ['Número não pode estar vazio', true]
        isValid = false
      } else {
        delete fieldErrors['identity']
      }
    } else {
      delete fieldErrors['identity']
    }

    // Verifica cônjuge
    if (spouse_status && this.state.selected === 3) {
      if (spouse_name === '' || !spouse_name) {
        fieldErrors['spouse_name'] = ['Nome não pode estar vazio', true]
        isValid = false
      } else {
        delete fieldErrors['spouse_name']
      }

      if (!emailRegex.test(spouse_email) || !spouse_email) {
        fieldErrors['spouse_email'] = ['Email inválido', true]
        isValid = false
      } else {
        delete fieldErrors['spouse_email']
      }

      if (spouse_cpf === '' || !spouse_cpf) {
        fieldErrors['spouse_cpf'] = ['Campo CPF é obrigatório', true]
        isValid = false
      } else {
        delete fieldErrors['spouse_cpf']
      }
    } else {
      delete fieldErrors['spouse_name']
      delete fieldErrors['spouse_email']
      delete fieldErrors['spouse_cpf']
    }

    this.setState({ fieldErrors })

    return isValid
  }

  async updateGuarantor(step) {
    const requestFields = { ...this.state.fields }

    const address = {
      additional_address: requestFields['additional_address'],
      address: requestFields['address'],
      city: requestFields['city'],
      neighborhood: requestFields['neighborhood'],
      number: requestFields['number'],
      state: requestFields['state'],
      zip_code: requestFields['zip_code'],
    }

    delete requestFields.additional_address
    delete requestFields.city
    delete requestFields.neighborhood
    delete requestFields.number
    delete requestFields.state
    delete requestFields.zip_code

    requestFields['address'] = address

    const trading_address = {
      additional_address: requestFields['trading_address_additional_address'],
      address: requestFields['trading_address_address'],
      city: requestFields['trading_address_city'],
      neighborhood: requestFields['trading_address_neighborhood'],
      number: requestFields['trading_address_number'],
      state: requestFields['trading_address_state'],
      zip_code: requestFields['trading_address_zip_code'],
    }

    delete requestFields.trading_address_additional_address
    delete requestFields.trading_address_address
    delete requestFields.trading_address_city
    delete requestFields.trading_address_neighborhood
    delete requestFields.trading_address_number
    delete requestFields.trading_address_state
    delete requestFields.trading_address_zip_code

    requestFields['trading_address'] = trading_address

    if (requestFields.marital_status)
      requestFields['marital_status_id'] = requestFields.marital_status.id

    let goodFields = goodObject(requestFields, {
      birth_date: {
        path: 'birth_date',
        format: (value) => {
          const isFormatted = moment(value, 'YYYY-MM-DD', true).isValid()

          if (isFormatted) return value

          return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        },
      },
      spouse_birth_date: {
        path: 'spouse_birth_date',
        format: (value) => {
          const isFormatted = moment(value, 'YYYY-MM-DD', true).isValid()

          if (isFormatted) return value

          return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        },
      },
      identity_expedition_date: {
        path: 'identity_expedition_date',
        format: (value) => {
          const isFormatted = moment(value, 'YYYY-MM-DD', true).isValid()

          if (isFormatted) return value

          return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        },
      },
      spouse_identity_expedition_date: {
        path: 'spouse_identity_expedition_date',
        format: (value) => {
          const isFormatted = moment(value, 'YYYY-MM-DD', true).isValid()

          if (isFormatted) return value

          return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        },
      },
      income: {
        path: 'income',
        format: (value) => rawNumber(value),
      },
      spouse_income: {
        path: 'spouse_income',
        format: (value) => rawNumber(value),
      },
      estimated_rent_value: {
        path: 'estimated_rent_value',
        format: (value) => rawNumber(value),
      },
      marital_status: {
        path: 'marital_status',
        format: (value) => +value,
      },
    })

    try {
      const response = await request.put(
        `/company/${this.props.defaultValue.company.id}/guarantor/${this.props.guarantorId}`,
        goodFields,
      )

      if (!response.success) return

      if (step === 4) {
        this.setState({
          formIsWorking: false,
          confirmationModal: true,
          success: true,
          message: 'Edição realizada com sucesso!',
        })
        setTimeout(() => {
          this.setState(
            {
              confirmationModal: false,
              modalIsOpen: false,
            },
            () => {
              const gaPayload = {
                companyId: this.props.activeCompany,
                company_name: this.props.companyInfo.companyName,
              }

              ga.logEvent('update_guarantor', gaPayload)

              this.back()
            },
          )
        }, 2500)
      }
    } catch (error) {
      if (step === 4) {
        const { errors } = error
        const message = errors[0].message

        this.setState({
          formIsWorking: false,
          confirmationModal: true,
          success: false,
          message: message,
        })
        setTimeout(() => {
          this.setState({
            confirmationModal: false,
          })
        }, 2500)
      }
    }

    // this.props.submit(
    //   `{company}/guarantor/${this.props.guarantorId}`,
    //   goodFields,
    //   "put"
    // );
  }

  requestRegistrationClose() {
    this.setState({
      confirmationModal: false,
      smallModalIsOpen: false,
    })
  }
  requestRegistration() {
    this.setState({
      smallModalIsOpen: true,
    })
  }

  async requestDelete() {
    try {
      const deleteUrl = `/company/${this.props.defaultValue.company.id}/guarantor/${this.props.guarantorId}`

      await request.delete(deleteUrl)

      this.props.notification({
        message: 'Registro excluído com sucesso',
        status: 'success',
      })

      this.props.history.goBack()
    } catch (erro) {
      this.props.notification({
        message: erro.message || 'Erro ao tentar excluir o Fiador',
        status: 'danger',
      })
    }
  }

  openDeleteModal() {
    this.setState({
      showExcludeModal: true,
    })
  }

  render() {
    const formConfig = {
      selected: this.state.selected,
      sections: [
        {
          formTitle: 'Editar fiador(a)',
          buttonTitle: 'Avançar',
          secondButtonTitle: 'Solicitar Edição',
          progressBar: true,
          sectionNumber: '1',
          sectionTitle: 'Resumo do(a) fiador(a)',
          progressTitle: 'Resumo',
        },
        {
          formTitle: 'Editar fiador(a)',
          buttonTitle: 'Avançar',
          secondButtonTitle: 'Solicitar Edição',
          progressBar: true,
          sectionNumber: '2',
          sectionTitle: 'Dados do(a) fiador(a)',
          progressTitle: 'Dados',
        },
        {
          formTitle: 'Editar fiador(a)',
          buttonTitle: 'Avançar',
          secondButtonTitle: 'Solicitar Edição',
          progressBar: true,
          sectionNumber: '3',
          sectionTitle: 'Endereço do(a) fiador(a)',
          progressTitle: 'Endereço',
        },
        {
          formTitle: 'Editar fiador(a)',
          buttonTitle: 'Avançar',
          secondButtonTitle: 'Solicitar Edição',
          progressBar: true,
          sectionNumber: '4',
          sectionTitle: 'Dados do(a) Cônjuge',
          progressTitle: 'Cônjuge',
        },
        {
          formTitle: 'Editar fiador(a)',
          buttonTitle: 'Concluir',
          secondButtonTitle: 'Solicitar Edição',
          progressBar: true,
          sectionNumber: '5',
          sectionTitle: 'Documentação',
          progressTitle: 'Documentos',
        },
      ],
    }

    const { selected } = formConfig

    const hideForwardButton = this.state.selected == 4
    const hideBackButton = this.state.selected == 0

    const current = this.props.defaultValue
    const address = {
      address: current.address,
      additional_address: current.additional_address,
      area: current.area,
      city: current.city,
      state: current.state,
      neighborhood: current.neighborhood,
      number: current.number,
      zip_code: current.zip_code,
    }
    const trading_address = {
      address: current.trading_address_address,
      additional_address: current.trading_address_additional_address,
      city: current.trading_address_city,
      state: current.trading_address_state,
      neighborhood: current.trading_address_neighborhood,
      number: current.trading_address_number,
      zip_code: current.trading_address_zip_code,
    }

    const { typeJuridical } = this.state.fields

    return (
      <Fragment>
        <Modal
          noTitleMobile
          requestRegistration
          isOpen
          isApp
          push={this.props.push}
          activeUser={this.props.activeUser}
          activeCompany={this.props.activeCompany}
          companyInfo={this.props.companyInfo}
          hideForwardButton={hideForwardButton}
          hideBackButton={hideBackButton}
          forward={this.forward.bind(this)}
          back={this.behind.bind(this)}
          close={this.back.bind(this)}
          formConfig={formConfig}
          isInvalid={this.state.formIsInvalid}
          callBack={this.callBack.bind(this)}
          isLoading={this.state.formIsWorking}
          requestRegistrationClick={this.requestRegistration.bind(this)}
          requestDeleteClick={this.openDeleteModal.bind(this)}
        >
          {selected === 0 && (
            <>
              <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                <ReactToPrint
                  trigger={() => (
                    <Button isBare isMedium>
                      <Icon name='fas fa-print' />
                      Imprimir
                    </Button>
                  )}
                  bodyClass='print-padding'
                  content={() => this.componentRef}
                  copyStyles={true}
                />
              </div>
              <div ref={(element) => (this.componentRef = element)}>
                <h1
                  className='visibleToPrint'
                  style={{ textAlign: 'center', marginBottom: 30, fontSize: 25 }}
                >
                  Dados do(a) fiador(a)
                </h1>
                <Grid>
                  <Grid.Col>
                    <UserName {...current} />
                    <PersonalData {...current} />
                    <DataSpouse {...current} />
                  </Grid.Col>
                  <Grid.Col>
                    {typeJuridical && (
                      <div>
                        <Address
                          {...this.props}
                          address={trading_address}
                          label='Endereço Comercial'
                        />
                        <br />
                        <br />
                        <br />
                      </div>
                    )}
                    <Address
                      {...this.props}
                      address={address}
                      label='Endereço Residencial'
                    />
                  </Grid.Col>
                </Grid>
              </div>
            </>
          )}
          {selected === 1 && (
            <PersonalDataClient
              {...this.state}
              handleChange={this.handleChange.bind(this)}
              showEstimatedRentValue={true}
              multiStepIndex={selected}
              isMultiStep
            />
          )}
          {selected === 2 && (
            <div>
              {typeJuridical && (
                <FullTradingAddress
                  {...this.state}
                  handleChange={this.handleChange.bind(this)}
                />
              )}

              <FullAddress
                {...this.state}
                handleChange={this.handleChange.bind(this)}
                multiStepIndex={selected}
                isMultiStep
              />
            </div>
          )}
          {selected === 3 && (
            <PersonalDataSpouse
              {...this.state}
              handleChange={this.handleChange.bind(this)}
              multiStepIndex={selected}
              isMultiStep
            />
          )}
          {selected === 4 && (
            <DocumentComponent
              {...this.state}
              noMessagebox
              isMultiStep
              multiStepIndex={selected}
              entityId={this.props.guarantorId}
              entityName='guarantor'
            />
          )}
        </Modal>

        <ConfirmationModal
          disableClose
          containerStyle={{ maxWidth: 500 }}
          headerStyle={{ backgroundColor: 'transparent' }}
          bodyStyle={{
            paddingTop: 0,
            paddingBottom: 35,
            paddingLeft: 35,
            paddingRight: 35,
          }}
          backgroundContentStyle={{ display: 'block' }}
          isOpen={this.state.confirmationModal}
          onClose={this.requestRegistrationClose.bind(this)}
        >
          <ConfirmationMessage
            success={this.state.success}
            message={this.state.message}
          />
        </ConfirmationModal>

        <SmallModal
          containerStyle={{ maxWidth: 500 }}
          headerStyle={{ backgroundColor: 'transparent' }}
          bodyStyle={{
            paddingTop: 0,
            paddingBottom: 35,
            paddingLeft: 35,
            paddingRight: 35,
          }}
          backgroundContentStyle={{ display: 'block' }}
          isOpen={this.state.smallModalIsOpen}
          onClose={this.requestRegistrationClose.bind(this)}
        >
          <RequestByEmail
            fullForm
            updateForm
            noMessagebox
            confirmationTrue
            title='Como você deseja solicitar o cadastro?'
            userId={this.props.guarantorId}
            companyId={this.props.defaultValue.company.id}
            entityName={'guarantor'}
            documents={[]}
          />
        </SmallModal>
        {this.state.showExcludeModal && (
          <ConfirmExcludeModal
            title='Excluir Fiador?'
            text='Confirmar exclusão deste fiador?'
            onClose={() =>
              this.setState({
                showExcludeModal: false,
              })
            }
            onExclude={this.requestDelete.bind(this)}
          />
        )}
      </Fragment>
    )
  }
}

export default formCreator(UpdateGuarantor)
